const namespace = {
  title: "",
} as const;

export default namespace;
